module.exports = __webpack_public_path__ + "static/media/nimesh.90174047.jpg";